import React from 'react';

/** A truncating text cell that keeps the full value available on hover. */
export function Truncated({ text, max = 320 }: { text: string; max?: number }): React.JSX.Element {
  return (
    <span
      title={text}
      style={{ display: 'inline-block', maxWidth: max, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'bottom' }}
    >
      {text}
    </span>
  );
}
